<template>
	<div class="lowest-common-multiple">
		<div>Common Multiples of {{ terms.slice(0, -1).join(', ') }} and {{ terms[terms.length - 1] }}</div>
		<ol class="steps">
			<li v-for="item in terms" class="step">Multiples of {{ item }}:
				<component :is="multiples(item)" />
			</li>
		</ol>
		<div>The L.C.M of {{ terms.slice(0, -1).join(', ') }} and {{ terms[terms.length - 1] }} is <span class="text-danger">{{ result }}</span></div>
	</div>
</template>
<script type="text/javascript">
	// operations=require('../settings/variables').operations;
	const $operations = require("../scripts/variables").operations;
	import UFCT from 'usefull-functions';

	export default{
		name:'lowest-common-multiple',
		props:{
			terms:{
				required: true,
				type: Array
			}
		},
		data(){
			return {
				// operations:operations,
				result: $operations.lcm(this.terms.filterInt()),
			}
		},
		methods: {
			multiples(nbre) {
				let lcm = this.result, res = [nbre], isResult = nbre == this.result, html = UFCT.tag('span', nbre, {class: `multiple ${isResult ? 'text-danger lcm' : ''}`});
				for(let i = 1; res[i - 1] < lcm + (3 * nbre); i++){
					let multiple = i * nbre;
					isResult = multiple == this.result
					html += ', ' + UFCT.tag('span', multiple, {class: `multiple ${isResult ? 'text-danger lcm' : ''}`});
					res.push(multiple);
				}
				return {
					name: 'MultiplesOfNumber',
					template: UFCT.tag('div', html + ', ---', { class: 'multiples-of-number' }),
					data() {
						return {}
					}
				}
				return res;
			}
		},
		computed: {}
	};
</script>